import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/sudamerica.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[6];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[7].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[7].path}`,
    titlePrev: `${modulo4.content[0].activities[5].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 7</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Nuestro país, el Perú, forma parte de Sudamérica.</li>
        <li>
          Observa el mapa y luego conversa con un compañero, compañera o
          familiar sobre las preguntas.
        </li>
      </ul>

      <div className="row mt-5 align-items-center">
        <div className="col-lg-6 col-md-6 col-12">
          <img src={Imagen1} alt="Familia" className="img-fluid mt-2" />
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <ul>
              <li>¿Qué países tienen fronteras con el Perú?</li>
              <li>¿Qué hay al oeste del Perú?</li>
              <li>¿Qué países no tienen salida al mar?</li>
              <li>¿Qué países están más al sur?</li>
              <li>¿Cuáles son los países más grandes?</li>
              <li>¿Cuáles son los más pequeños?</li>
              <li>¿En qué países de Sudamérica se habla castellano?</li>
              <li>
                ¿Es útil que el castellano se hable en casi toda Sudamérica?
              </li>
            </ul>
          </Card>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Observen el mapa y lean los nombres de países y océanos. Lea las
          preguntas y luego dialoguen sobre las respuestas. Destaque la
          importancia del castellano como lengua predominante en casi todos los
          países salvo Brasil (portugués), Guyana (inglés), Guayana Francesa
          (francés) y Surinam (holandés).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
